import { API, authClient } from "../index";

export const getOfferStatus = (accessToken) => {
	return authClient(accessToken).get(`${API}/offer-status`);
};
